export const MODAL_TYPES = {
    default: 'default',
    wishlistReminders: 'wishlistReminders',
    selling: 'selling'
};

export const CHANNEL_TAG_GROUPS = {
    wishlistReminders: [
        'wishlist_reminder_3_min_optin',
        'wishlist_reminder_15_min_optin'
    ],
    buyingListingOutbid: ['member_outbid_optin'],
    buyingListingWon: ['member_won_optin'],
    sellingListingFirstBid: ['selling_first_bid_optin'],
    sellingListingAllBids: ['selling_new_bid_optin'],
    sellingListingSold: ['selling_sold_optin'],
    sellingPaymentReceived: ['selling_payment_received_optin']
};
